import { TRule } from '../../typings';

export const INTERSPRINT_STOCKLIST_RULESET: TRule[] = [
  {
    type: 'rule.map',
    sourceKey: 'c.eancode',
    destination: 'product',
    targetKey: 'ean',
  },
  {
    type: 'rule.map',
    sourceKey: 'c.available',
    destination: 'product',
    targetKey: 'qty',
    outputType: 'number',
  },
  {
    type: 'rule.map',
    sourceKey: 'c.itemcode',
    destination: 'product',
    targetKey: 'supplierCode',
  },
  {
    type: 'rule.template',
    destination: 'product',
    targetKey: 'packageQuantity',
    template: '1',
    outputType: 'number',
  },
];
